import { createContext, useState, useEffect } from "react";
import Sketchfab from "@sketchfab/viewer-api";

const initialState = {
	api: undefined,
	ready: false,
	mat: undefined,
};

export const SketchfabContext = createContext(initialState);

export const SketchfabProvider = ({
	modelUID,
	initialNodes,
	viewerRef,
	children,
}) => {
	const [api, setApi] = useState();
	const [ready, setReady] = useState(false);
	const [mat, setMat] = useState();

	useEffect(() => {
		if (viewerRef.current) {
			let client = new Sketchfab(viewerRef.current);

			client.init(modelUID, {
				success: (api) => {
					setApi(api);

					api.addEventListener("viewerready", () => {
						api.getNodeMap(function (err, nodes) {
							setReady(true);
							// console.log("ready");
							if (!err && initialNodes) {
								Object.keys(nodes).forEach((key) =>
									api.hide(nodes[key].instanceID)
								);
								initialNodes.forEach((node) => api.show(node));
							}
						});
						api.getMaterialList(function (err, materials) {
							if (!err) {
								api.getTextureList(function (err, textures) {
									if (!err) {
										let material = {
											/* function to update texture of a material
											 *
											 * @params
											 *  materialName: string contains name of 3d model material to be updated
											 *  textureName: string contains name of 3d model texture to apply
											 *
											 * @example
											 *   updateTexture("Wood-SPRUCE","wood_DIFF.jpg");
											 */
											updateTexture: (materialName, textureName) => {
												/* seach for the material to be updated */
												var mat2update = materials.find(
													(material) => material.name === materialName
												);
												if (mat2update) {
													//console.log(materials);

													/* seach for the texture to be applied */
													var texture2apply = textures.find(
														(texture) => texture.name === textureName
													);

													if (texture2apply) {
														/* apply textre to material */
														mat2update.channels.AlbedoPBR.texture.uid =
															texture2apply.uid;

														/* update material to take effect */
														api.setMaterial(mat2update, function (err) {
															if (!err) {
															}
														});
													}
												}
											},

											updateColor: (materialName, colorVector) => {
												/* seach for the material to be updated */
												var mat2update = materials.find(
													(material) => material.name === materialName
												);
												if (mat2update) {
													/* apply new color to material */
													mat2update.channels.AlbedoPBR.color = colorVector;
													/* update material to take effect */
													api.setMaterial(mat2update, function (err) {
														if (!err) {
															// console.log("material is updated");
														}
													});
												}
											},
										};
										setMat(material);
									}
								});
							}
						});
					});
				},
				error: () => {
					// console.log("Viewer error");
				},
				autostart: 1,
				transparent: 1,
				ui_controls: 0, // Premium account only
				ui_infos: 0, // Premium account only
			});
		}
	}, [modelUID, viewerRef]);

	return (
		<SketchfabContext.Provider value={{ api, ready, mat }}>
			{children}
		</SketchfabContext.Provider>
	);
};
